import { Map } from 'immutable';
import * as actionTypes from '../constants/actionTypes';

const init = Map({});

const respondentNameReducer = (state = init, action) => {
    switch (action.type) {
    case actionTypes.RESPONDENT_NAME:
        return state.set('firstName', action.firstName).set('lastName', action.lastName)
            .set('surveyId', action.surveyId).set('languageId', action.languageId)
            .set('respondent_email', action.respondent_email)
            .set('respondentId', action.respondentId)
            .set('respondentRoleId', action.respondentRoleId)
            .set('respondentRoleName', action.respondentRoleName)
            .set('userRoleId', action.userRoleId)
            .set('userRole', action.userRole)
            .set('lastQuestion', action.lastQuestion)
            .set('questionList', action.questionList)
            .set('accountId', action.accountId)
            .set('is_retake', action.is_retake)
            .set('has_pending_batch_survey', action.has_pending_batch_survey)
            .set('has_engagement_module', action.has_engagement_module);

    case actionTypes.ENGAGEMENT_SURVEY_TOKEN:
        return state.merge({ 'engagementSurveyToken': action.engagementSurveyToken });
    default:
        return state;
    }
};

export default respondentNameReducer;
